import {
  Component,
  OnInit
} from '@angular/core';
@Component({

  selector: 'rw-xBody',  // <home></home>

  styles: [require('./xBody.component.css')],

  template: require('./xBody.component.html')
})
export class XBodyComponent implements OnInit {

  public selectedCity=1;


  /**
   * TypeScript public modifiers
   */
  constructor() {
  }



  public ngOnInit() {


  }



}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/xBodyComponent/xBody.component.ts